export default __webpack_public_path__ + "static/media/05_Fair_loudness.eea8f6ab.mp3";